'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {AuthModalMode} from '../../enums/AuthModalMode';
import {AuthForm} from '../AuthForm';

export function MobileLoginView(props) {
  return (
    <div className={classNames("MobileLogin", props.className)}>
      <AuthForm
        className="MobileLogin__content"
        allowedModes={AuthModalMode.LOGIN_AND_SIGNUP}
        initialMode={AuthModalMode.LOGIN}
      />
    </div>
  );
}

MobileLoginView.propTypes = {
  className: T.string,
};

MobileLoginView.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./src/js/auth/components/MobileLogin/MobileLoginView.js